export class StepActivities {
    constructor(data) {
        Object.defineProperty(this, "stepActivityList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "graphScales", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.stepActivityList = data.stepActivityList.map((v) => new StepActivity(v));
        this.graphScales = data.graphScales;
    }
}
export class StepActivity {
    constructor(data) {
        Object.defineProperty(this, "dateAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "steps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "calories", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.dateAt = data.dateAt;
        this.steps = data.steps;
        this.calories = data.calories;
    }
}
